import BarberAvaialability from "../BarberAvailability";
import BarberVipHandling from "../BarberVIPHandling";
import { useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { jwtDecode } from "jwt-decode";
import useAuth from '../../../hooks/useAuth';  // Import the custom hook
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';


export default function BarberWorkSettings() {
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [barberDays, setBarberDays] = useState('');
  const [workStart, setWorkStart] = useState('');
  const [workEnd, setWorkEnd] = useState('');
  const [notification, setNotification] = useState(""); // State for the notification message
  const axiosPrivate = useAxiosPrivate();

  const { auth } = useAuth();
  const decoded = auth?.token ? jwtDecode(auth.token) : undefined;
  const apiUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_LOCAL // Use local API in development
    : process.env.REACT_APP_API;      // Use production API in production
  useEffect(() => {
    fetchBarberDays();
  }, []);


  const handleBarberDaysChange = async (barberDays) => {
    axiosPrivate
    .put(`${apiUrl}/barbers/${decoded.id}`, { barberDays })
    .then(() => {
      setNotification(`Trenutno je moguće zakazati ${barberDays} dana unapred.`);
      setTimeout(() => setNotification(""), 10000);
    })
    .catch((error) => {
      console.error("Error updating availability:", error);
      setNotification("Problem sa serverom. Probaj Logout i Login, pa zovi Darka :).");
      setTimeout(() => setNotification(""), 10000);
    });
  
  };
  

  const fetchBarberDays = async () => {
    axiosPrivate
    .get(`${apiUrl}/barbers/${decoded.id}`)
    .then((response) => {
      setBarberDays(response.data.barberDays);
      setWorkEnd(response.data.workEnd);
      setWorkStart(response.data.workStart);
    })
    .catch((error) => {
      console.error("Error fetching barber details:", error);
      setError("Problem sa serverom, probaj Logout i Login. Pa zovi Darka :).");
    });
  
  }
  

  
  const handleWorkTimeChange = async (start, end) => {
    try {
      const barberId = decoded?.id;
      if (!barberId) throw new Error("Barber ID is undefined.");
  
      const response = await axiosPrivate.put(`${apiUrl}/barbers/${barberId}`, {
        workStart: start,
        workEnd: end,
      });
  
      setNotification(`Radno vreme promenjeno na: ${start} - ${end}`);
      setTimeout(() => setNotification(""), 10000);
    } catch (err) {
      console.error("Error updating work time:", err);
      setNotification("Problem sa serverom. Probaj Logout i Login, pa zovi Darka :).");
      setTimeout(() => setNotification(""), 10000);
    }
  };
  return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-zinc-950 p-6">
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <BarberVipHandling />
        <BarberAvaialability />
        
      <div className="flex flex-col items-center space-y-6 w-full max-w-md mx-auto p-4">
        <button
          onClick={() => navigate("/barber-dashboard")}
          className="mt-6 w-48 p-4 bg-zinc-800 text-white rounded-2xl shadow hover:bg-zinc-700 transition"
        >
          ← Nazad na Dashboard
        </button>
      </div>

    </div>
  )
}
